<template>
  <div class="Schedule">
    <div class="page-title">{{ title }}</div>
    <div>
      <div class="flex">
        <div class="inline">
          <APeriodSelector
            ref="period"
            :value="search_period"
            hide-select
            @change="handleChangePeriod"
          />
        </div>
        <div class="inline">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
            >검색(F5)</el-button
          >
        </div>
        <div class="search-left-space inline" />
        <div class="inline">
          <el-button size="mini" round @click="handleClickInit"
            >초기화</el-button
          >
        </div>
      </div>
      <div class="flex">
        <div class="font-prop inline">담당자</div>
        <div class="inline">
          <el-input
            v-model="search_charger"
            class="input-with-select"
            size="mini"
            placeholder="담당자"
            :style="{ width: searchWidth }"
          >
          </el-input>
        </div>
        <div class="search-left-space inline" />
        <div class="font-prop inline">거래처</div>
        <div class="inline">
          <el-input
            v-model="search_customer"
            class="input-with-select"
            size="mini"
            placeholder="거래처"
            :style="{ width: searchWidth }"
          >
          </el-input>
        </div>
        <div class="search-left-space inline" />
        <div class="font-prop inline" :style="{ width: '48px' }">연락처</div>
        <div class="inline">
          <el-input
            v-model="search_tel"
            class="input-with-select"
            size="mini"
            placeholder="연락처"
            :style="{ width: searchWidth }"
          >
          </el-input>
        </div>
      </div>

      <div class="flex">
        <div class="lt-area flex-auto">
          <div
            class="search-top-space font-prop inline"
            :style="{ width: '36px' }"
          >
            현장
          </div>
          <div class="search-top-space inline">
            <el-input
              v-model="search_field"
              class="input-with-select"
              size="mini"
              placeholder="현장"
              :style="{ width: searchWidth }"
            >
            </el-input>
          </div>
          <div class="search-left-space inline" />
          <div
            class="search-top-space font-prop inline"
            :style="{ width: '36px' }"
          >
            주소
          </div>
          <div class="search-top-space inline">
            <el-input
              v-model="search_address"
              class="input-with-select"
              size="mini"
              placeholder="주소"
              :style="{ width: searchWidth }"
            >
            </el-input>
          </div>
          <div class="search-left-space inline" />
          <div class="search-top-space font-prop inline">처리내용</div>
          <div class="search-top-space inline">
            <el-input
              v-model="search_task"
              class="input-with-select"
              size="mini"
              placeholder="처리내용"
              :style="{ width: searchWidth }"
            >
            </el-input>
          </div>
          <div class="search-left-space inline" />
          <div class="search-top-space font-prop inline">수주번호</div>
          <div class="search-top-space inline">
            <el-input
              v-model="search_code"
              class="input-with-select"
              size="mini"
              placeholder="수주번호"
              :style="{ width: searchWidth }"
            >
            </el-input>
          </div>
        </div>
        <div class="rt-area flex-fixed align-right">
          <el-button
            icon="fas fa-file-excel fa-lg"
            style="padding: 8px;"
            circle
            @click="handleClickExcel"
          ></el-button>
        </div>
      </div>
      <ATable
        ref="table"
        v-loading="loading"
        rowKey="uid"
        buttons-width="400px"
        max-height="720px"
        :data="sortedItems"
        :disable_insert="!has_grant_write"
        hideTopPanel
        hide-pagination
        border
        @row-click="handleRowClick"
        @clicked-create="handleClickedCreate"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="selection"
          align="center"
          :width="$width.selection"
          fixed
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.index"
        />
        <el-table-column
          prop="schedule_date"
          label="일자"
          :width="$width.date"
        />
        <el-table-column
          prop="contract_code"
          label="수주번호"
          sortable="custom"
        />
        <el-table-column
          prop="confirmed_at"
          label="확인"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="area_name"
          label="구역"
          width="70"
          sortable="custom"
        />
        <el-table-column
          prop="delivery_way_flag_name"
          label="구분"
          width="80"
          sortable="custom"
        />
        <el-table-column
          prop="charger"
          label="담당자"
          width="100"
          show-overflow-tooltip
          sortable="custom"
        />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="90"
          show-overflow-tooltip
          sortable="custom"
        />
        <el-table-column
          prop="tel"
          label="연락처"
          width="115"
          show-overflow-tooltip
        />
        <el-table-column
          prop="field"
          label="현장"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column prop="addr" label="주소" show-overflow-tooltip />
        <el-table-column
          prop="task"
          label="처리내용"
          width="200"
          show-overflow-tooltip
        />
        <el-table-column
          prop="desc"
          label="비고"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            :disabled="selection.length < 1"
            @click="handleClickBulkChange"
            >{{ $t("button.bulk_change") }}</el-button
          >
          <el-button
            :disabled="selection.length < 1"
            @click="handleClickConfirm"
            >확인등록</el-button
          >
          <el-button
            :disabled="selection.length < 1"
            @click="handleClickConfirmCancel"
            >확인취소</el-button
          >
        </div>
      </ATable>
    </div>
    <el-dialog
      top="0"
      custom-class="form-dialog"
      destroyOnClose
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <ScheduleForm
        ref="form"
        v-if="dialogVisible"
        :data="selectedData"
        :has_grant_write="has_grant_write"
        @completed="handleCompletedForm"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="400px"
      destroyOnClose
      :title="$t('button.bulk_change')"
      :visible.sync="dialog2Visible"
      :close-on-click-modal="false"
    >
      <ScheduleBulkChange
        v-if="dialog2Visible"
        :ids="selectionIds"
        @completed="handleCompletedBulkChange"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="400px"
      destroyOnClose
      title="엑셀 다운로드"
      :visible.sync="excelDialogVisible"
      :close-on-click-modal="false"
    >
      <div class="download-link-wrap">
        <span class="download-link" @click="handleClickDownloadCurrentExcel">
          <i class="fas fa-file-excel mr-default"></i>현재 상태로 다운로드
        </span>
        <span class="download-link" @click="handleClickDownloadMergedExcel">
          <i class="fas fa-file-excel mr-default"></i>같은 수주건 끼리 묶어서
          다운로드
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import { sort_items } from "@/common/mixins/sort_items";
import ScheduleForm from "./ScheduleForm";
import ScheduleBulkChange from "./ScheduleBulkChange";
// import XLSX from "xlsx";
import * as XLSX from "xlsx-js-style";

export default {
  name: "Schedule",
  mixins: [form_container, authority_level, sort_items],
  components: { ScheduleForm, ScheduleBulkChange },
  data() {
    return {
      title: this.$t("title.integrated_schedule"),
      date: this.util.getDate(),
      search_period: { value: "0d" },
      period: {},
      period_options: [
        { value: "0d", label: "오늘" },
        { value: "1w", label: "1주" },
        { value: "1m", label: "1개월" },
      ],
      loading: false,
      items: [],
      source_items: [],
      dialogVisible: false,
      dialog2Visible: false,
      excelDialogVisible: false,
      selectedData: null,
      selection: [],
      searchWidth: "200px",
      search_charger: "",
      search_customer: "",
      search_tel: "",
      search_field: "",
      search_address: "",
      search_task: "",
      search_code: "",
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    selectionIds() {
      if (this.selection.length < 1) {
        return [];
      }
      return this.selection.map((s) => s.uid);
    },
    has_grant_write() {
      return this.isWriteLevel("total_schedule");
    },
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.listScheduleUnion(this.period).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.applyContractDetailData(res.data);
        this.source_items = res.data;
        let filteredItems = this.filterItems(this.source_items).sort(
          this.sortItems
        );
        this.items = filteredItems.sort(this.sortScheduleDataNContractCode);
      });
    },
    sortScheduleDataNContractCode(a, b) {
      if (a.schedule_date === b.schedule_date) {
        let x = a.contract_code;
        let y = b.contract_code;
        if (!x || !y) return -1;
        return x < y ? -1 : x > y ? 1 : 0;
      }
      return a.schedule_date > b.schedule_date ? 1 : -1;
    },
    applyContractDetailData(data) {
      data.forEach((item) => {
        if (item.uid.startsWith("contract")) {
          if (item.detail_zipcode) {
            item.contract_zipcode = item.zipcode;
            item.zipcode = item.detail_zipcode;
          } else {
            item.contract_zipcode = item.zipcode;
            item.detail_zipcode = item.zipcode;
          }
          if (item.detail_destination) {
            item.contract_addr = item.addr;
            item.addr = item.detail_destination;
          } else {
            item.contract_addr = item.addr;
            item.detail_destination = item.addr;
          }
          if (item.detail_charger) {
            item.contract_charger = item.charger;
            item.charger = item.detail_charger;
          } else {
            item.contract_charger = item.charger;
            item.detail_charger = item.charger;
          }
          if (item.detail_delivery_date) {
            item.contract_delivery_date = item.schedule_date;
            item.schedule_date = item.detail_delivery_date;
          } else {
            item.contract_delivery_date = item.schedule_date;
            item.detail_delivery_date = item.schedule_date;
          }
          if (item.detail_delivery_way_flag) {
            item.contract_delivery_way_flag = item.delivery_way_flag;
            item.delivery_way_flag = item.detail_delivery_way_flag;
          } else {
            item.contract_delivery_way_flag = item.delivery_way_flag;
            item.detail_delivery_way_flag = item.delivery_way_flag;
          }
        }
        item.delivery_way_flag_name = this.resolveDeliveryWay(
          item,
          null,
          item.delivery_way_flag
        );
      });
    },
    handleClickInit() {
      this.search_charger = "";
      this.search_customer = "";
      this.search_tel = "";
      this.search_field = "";
      this.search_address = "";
      this.search_task = "";
      this.search_code = "";
      this.items = this.source_items;
    },
    popupForm(data) {
      this.selectedData = data;
      this.dialogVisible = true;
    },
    resolveDeliveryWay(row, column, value) {
      let ar = row.uid.split("_");
      switch (ar[0]) {
        case "service":
          return "A/S";
        case "assemble":
          return "조립";
        default:
          if (value) {
            let flag = this.system.options.delivery_way_flag.find(
              (f) => f.value === value
            );
            if (flag) {
              return flag.label;
            }
          }
          return "";
      }
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleRowClick(data) {
      this.popupForm(Object.assign({}, data));
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleClickedCreate() {
      this.popupForm();
    },
    handleClickBulkChange() {
      this.dialog2Visible = true;
    },
    handleCompletedForm(result) {
      this.dialogVisible = false;
      if (!result) {
        return;
      }
      this.loadData();
    },
    handleCompletedBulkChange(result) {
      this.dialog2Visible = false;
      if (!result) {
        return;
      }
      this.loadData();
    },
    handleChangeDate() {
      this.loadData();
    },
    handleClickConfirm() {
      this.loading = true;
      this.api.updateScheduleConfirm(this.selectionIds).then((res) => {
        this.handleResponse(res);
      });
    },
    handleClickConfirmCancel() {
      this.loading = true;
      this.api.updateScheduleConfirmCancel(this.selectionIds).then((res) => {
        this.handleResponse(res);
      });
    },
    handleResponse(res) {
      this.loading = false;
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, "변경되었습니다.");
      this.loadData();
    },
    handleClickExcel() {
      this.excelDialogVisible = true;
    },
    handleClickDownloadCurrentExcel() {
      this.$refs.table.downloadExcel();
    },
    handleClickDownloadMergedExcel() {
      const mergedItems = [];
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        const mIndex = mergedItems.findIndex(
          (i) => i.contract_code === item.contract_code
        );
        if (!item.contract_code || mIndex === -1) {
          const copyItem = { ...item };
          copyItem.task = [item.task];
          copyItem.desc = [item.desc];
          mergedItems.push(copyItem);
          continue;
        } else {
          mergedItems[mIndex].task.push(item.task);
          mergedItems[mIndex].desc.push(item.desc);
        }
      }

      let excelItems = [];
      let wsrows = [{ hpt: 18 }];
      for (let i = 0; i < mergedItems.length; i++) {
        const item = mergedItems[i];
        wsrows.push({ hpt: 18 * item.task.length });
        excelItems.push({
          No: mergedItems.length - i,
          일자: item.schedule_date,
          수주번호: item.contract_code,
          확인: item.confirmed_at
            ? this.util.getDateString(item.confirmed_at)
            : "",
          구역: item.area_name,
          구분: item.delivery_way_flag_name,
          담당자: item.charger,
          거래처: item.customer_name,
          연락처: item.tel,
          현장: item.field,
          주소: item.detail_destination,
          처리내용: item.task.join("\r\n"),
          비고: item.desc.join("\r\n"),
          등록자: item.created_user_name,
          수정자: item.modified_user_name,
          등록일: this.util.getDateString(item.created_at),
          수정일: this.util.getDateString(item.modified_at),
        });
      }

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelItems, {
        type: "binary",
        cellDates: true,
        dateNF: "YYYY-MM-DD",
      });
      var wscols = [
        { wpx: 50 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 50 },
        { wpx: 50 },
        { wpx: 50 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 200 },
        { wpx: 300 },
        { wpx: 400 },
        { wpx: 400 },
        { wpx: 50 },
        { wpx: 50 },
        { wpx: 100 },
        { wpx: 100 },
      ];
      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;
      for (const i in ws) {
        let cell = XLSX.utils.decode_cell(i);
        if (cell.c === 11 || cell.c === 12) {
          ws[i].s = { alignment: { wrapText: true } };
        }
      }
      XLSX.utils.book_append_sheet(wb, ws, "file");
      XLSX.writeFile(wb, "file.xlsx");
      this.loadingDownload = false;
    },
    filterItems(items) {
      return items.filter((item) => {
        // 담당자
        if (
          !(
            this.search_charger === "" ||
            (item.charger !== null &&
              item.charger.indexOf(this.search_charger) > -1)
          )
        ) {
          return false;
        }
        // 거래처
        if (
          !(
            this.search_customer === "" ||
            (item.customer_name !== null &&
              item.customer_name.indexOf(this.search_customer) > -1)
          )
        ) {
          return false;
        }
        // 연락처
        if (
          !(
            this.search_tel === "" ||
            (item.tel !== null && item.tel.indexOf(this.search_tel) > -1)
          )
        ) {
          return false;
        }
        // 현장
        if (
          !(
            this.search_field === "" ||
            (item.field !== null && item.field.indexOf(this.search_field) > -1)
          )
        ) {
          return false;
        }
        // 주소
        if (
          !(
            this.search_address === "" ||
            (item.addr !== null && item.addr.indexOf(this.search_address) > -1)
          )
        ) {
          return false;
        }
        // 처리내용
        if (
          !(
            this.search_task === "" ||
            (item.task !== null && item.task.indexOf(this.search_task) > -1)
          )
        ) {
          return false;
        }
        // 수주번호
        if (
          !(
            this.search_code === "" ||
            (item.contract_code !== null &&
              item.contract_code.indexOf(this.search_code) > -1)
          )
        ) {
          return false;
        }
        return true;
      });
    },
    sortItems(a, b) {
      if (a.schedule_date !== b.schedule_date) {
        return a.schedule_date > b.schedule_date ? 1 : -1;
      } else if (a.customer_name !== b.customer_name) {
        return a.customer_name > b.customer_name ? 1 : -1;
      } else {
        return 0;
      }
    },
  },
};
</script>

<style lang="scss">
.Schedule {
  .search-left-space {
    margin-left: 15px;
  }
  .search-top-space {
    margin-top: 12px;
  }
  .font-prop {
    font-weight: bold;
    font-size: 12px;
    margin-top: 2px;
    margin-right: 10px;
    text-align: right;
  }
  .download-link-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .download-link {
      margin: 10px 0;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
